// // src/redux/slices/customerReportSlice.js
// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import axios from 'axios';
// import { toast } from 'react-toastify';

// const BASE_URL = process.env.REACT_APP_API_URL;
// const superAdminId = localStorage.getItem('userid') || 1;

// // Fetch Customers
// export const fetchCustomers = createAsyncThunk(
//   'customers/fetchCustomers',
//   async (_, thunkAPI) => {
//     try {
//       const res = await axios.get(`${BASE_URL}/customers?superAdminId=${localStorage.getItem('adminuserId')}`);
//       return res.data.data;
//     } catch (error) {
//       toast.error("Failed to fetch customers");
//       return thunkAPI.rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// // Update Customer
// export const updateCustomer = createAsyncThunk(
//   'customers/updateCustomer',
//   async ({ id, payload }, thunkAPI) => {
//     try {
//       const res = await axios.put(`${BASE_URL}/update-customer/${id}`, payload);
//       toast.success("Customer updated successfully");
//       thunkAPI.dispatch(fetchCustomers());
//       return { id, ...payload };
//     } catch (error) {
//       toast.error(error.response?.data?.message || "Update failed");
//       return thunkAPI.rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// // Update PIN
// export const updateCustomerPin = createAsyncThunk(
//   'customers/updateCustomerPin',
//   async ({ id, oldPin, newPin, confirmPin }, { rejectWithValue }) => {
//     try {
//       const response = await axios.put(
//         `${BASE_URL}/update-pin/${id}`,
//         { oldPin, newPin, confirmPin }
//       );
//       toast.success("PIN updated successfully");
//       return response.data;
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed to update PIN");
//       return rejectWithValue(err.response.data);
//     }
//   }
// );

// // Update Password
// export const updateCustomerPassword = createAsyncThunk(
//   'customers/updateCustomerPassword',
//   async ({ id, oldPassword, newPassword, confirmPassword }, { rejectWithValue }) => {
//     try {
//       const response = await axios.put(
//         `${BASE_URL}/update-password/${id}`,
//         {
//           oldPassword,
//           newPassword,
//           confirmPassword
//         }
//       );
//       toast.success("Password updated successfully");
//       return response.data;
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed to update password");
//       return rejectWithValue(err.response?.data || { message: "Unknown error" });
//     }
//   }
// );

// // Delete Customer
// export const deleteCustomer = createAsyncThunk(
//   'customers/deleteCustomer',
//   async (id, thunkAPI) => {
//     try {
//       const res = await axios.delete(`${BASE_URL}/delete-customer/${id}`);
//       toast.success("Customer deleted successfully");
//       thunkAPI.dispatch(fetchCustomers());
//       return id;
//     } catch (error) {
//       toast.error("Failed to delete customer");
//       return thunkAPI.rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// // Slice
// const customerSlice = createSlice({
//   name: 'customers',
//   initialState: {
//     customers: [],
//     loading: false,
//     error: null,
//     success: null,
//   },
//   reducers: {
//     clearMessages: (state) => {
//       state.error = null;
//       state.success = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchCustomers.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(fetchCustomers.fulfilled, (state, action) => {
//         state.loading = false;
//         state.customers = action.payload;
//       })
//       .addCase(fetchCustomers.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })

//       .addCase(updateCustomer.fulfilled, (state, action) => {
//         state.success = 'Customer updated successfully';
//         const updated = action.payload;
//         state.customers = state.customers.map((c) =>
//           c.id === updated.id ? { ...c, ...updated } : c
//         );
//       })
//       .addCase(updateCustomer.rejected, (state, action) => {
//         state.error = action.payload;
//       })

//       .addCase(deleteCustomer.fulfilled, (state, action) => {
//         state.success = 'Customer deleted successfully';
//         state.customers = state.customers.filter(c => c.id !== action.payload);
//       })
//       .addCase(deleteCustomer.rejected, (state, action) => {
//         state.error = action.payload;
//       })

//       .addCase(updateCustomerPin.rejected, (state, action) => {
//         state.error = action.payload;
//       })
//       .addCase(updateCustomerPassword.rejected, (state, action) => {
//         state.error = action.payload;
//       });
//   },
// });

// export const { clearMessages } = customerSlice.actions;
// export default customerSlice.reducer;
// src/redux/slices/customerReportSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_API_URL;

// 🔹 Helper: Auth headers if needed
const getAuthHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
  },
});

// =======================
// Async Thunks
// =======================

// Fetch Customers with Backend Pagination
// export const fetchCustomers = createAsyncThunk(
//   "customers/fetchCustomers",
//   async ({ page = 1, limit = 10 ,userId,branchId,employeeId}, thunkAPI) => {
//     try {
//       const res = await axios.get(
//         `${BASE_URL}/customers?superAdminId=${localStorage.getItem(
//           "adminuserId"
//         )}&page=${page}&limit=${limit}${
//           userId ? `&userId=${encodeURIComponent(userId)}` : ""}`,
//         getAuthHeaders()
//       );

//       // ✅ Expected backend response:
//       // { data: [...], totalPages, totalRecords, currentPage }
//       return res.data;
//     } catch (error) {
//       toast.error("Failed to fetch customers");
//       return thunkAPI.rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );


export const fetchCustomers = createAsyncThunk(
  "customers/fetchCustomers",
  async ({ page = 1, limit = 10, userId, employeeId }, thunkAPI) => {
    try {
      const superAdminId = localStorage.getItem("adminuserId");
      
      // Base URL with mandatory params
      let url = `${BASE_URL}/customers?superAdminId=${superAdminId}&page=${page}&limit=${limit}`;

      // Append optional filters only if they exist
      if (userId) url += `&userId=${encodeURIComponent(userId)}`;
      // if (branchId) url += `&branchId=${encodeURIComponent(branchId)}`;
      if (employeeId) url += `&employeeId=${encodeURIComponent(employeeId)}`;

      const res = await axios.get(url, getAuthHeaders());

      return res.data;
    } catch (error) {
      // Toast ko yaha rakhna option hai, lekin error handle zaroori hai
      const message = error.response?.data?.message || "Failed to fetch customers";
      toast.error(message);
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Update Customer
export const updateCustomer = createAsyncThunk(
  "customers/updateCustomer",
  async ({ id, payload }, thunkAPI) => {
    try {
      const res = await axios.put(
        `${BASE_URL}/update-customer/${id}`,
        payload,
        getAuthHeaders()
      );
      toast.success("Customer updated successfully");

      // 🔹 Refresh list (keeps pagination context)
      const { currentPage, limit } = thunkAPI.getState().customers.pagination;
      thunkAPI.dispatch(fetchCustomers({ page: currentPage, limit }));

      return { id, ...payload };
    } catch (error) {
      toast.error(error.response?.data?.message || "Update failed");
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Update PIN
export const updateCustomerPin = createAsyncThunk(
  "customers/updateCustomerPin",
  async ({ id, oldPin, newPin, confirmPin }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${BASE_URL}/update-pin/${id}`,
        { oldPin, newPin, confirmPin },
        getAuthHeaders()
      );
      toast.success("PIN updated successfully");
      return response.data;
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to update PIN");
      return rejectWithValue(err.response?.data || { message: "Unknown error" });
    }
  }
);

// Update Password
export const updateCustomerPassword = createAsyncThunk(
  "customers/updateCustomerPassword",
  async (
    { id, oldPassword, newPassword, confirmPassword },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.put(
        `${BASE_URL}/update-password/${id}`,
        { oldPassword, newPassword, confirmPassword },
        getAuthHeaders()
      );
      toast.success("Password updated successfully");
      return response.data;
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to update password");
      return rejectWithValue(err.response?.data || { message: "Unknown error" });
    }
  }
);

// Delete Customer
export const deleteCustomer = createAsyncThunk(
  "customers/deleteCustomer",
  async (id, thunkAPI) => {
    try {
      const res = await axios.delete(
        `${BASE_URL}/delete-customer/${id}`,
        getAuthHeaders()
      );
      toast.success("Customer deleted successfully");

      // 🔹 Refresh list after delete
      const { currentPage, limit } = thunkAPI.getState().customers.pagination;
      thunkAPI.dispatch(fetchCustomers({ page: currentPage, limit }));

      return id;
    } catch (error) {
      toast.error("Failed to delete customer");
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

// =======================
// Slice
// =======================
const customerSlice = createSlice({
  name: "customers",
  initialState: {
    customers: [],
    pagination: {
      currentPage: 1,
      totalPages: 0,
      totalRecords: 0,
      limit: 10,
    },
    loading: false,
    error: null,
    success: null,
  },
  reducers: {
    clearMessages: (state) => {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Customers
      .addCase(fetchCustomers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCustomers.fulfilled, (state, action) => {
        state.loading = false;
        state.customers = action.payload.data || [];
        state.pagination = {
          currentPage: action.payload.currentPage,
          totalPages: action.payload.totalPages,
          totalRecords: action.payload.totalRecords,
          limit: state.pagination.limit,
        };
      })
      .addCase(fetchCustomers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update Customer
      .addCase(updateCustomer.fulfilled, (state, action) => {
        state.success = "Customer updated successfully";
        const updated = action.payload;
        state.customers = state.customers.map((c) =>
          c.id === updated.id ? { ...c, ...updated } : c
        );
      })
      .addCase(updateCustomer.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Delete Customer
      .addCase(deleteCustomer.fulfilled, (state, action) => {
        state.success = "Customer deleted successfully";
        state.customers = state.customers.filter((c) => c.id !== action.payload);
      })
      .addCase(deleteCustomer.rejected, (state, action) => {
        state.error = action.payload;
      })

      // PIN/Password errors
      .addCase(updateCustomerPin.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(updateCustomerPassword.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { clearMessages } = customerSlice.actions;
export default customerSlice.reducer;
